module.exports = __webpack_public_path__ + "static/media/image.a7dc73e2.png";